import styled from '@emotion/styled';
import { Text, tokens } from '@hotjar/hotsauce';

export const RECORDING_TILE_WIDTH = 249;
export const RECORDING_TILE_HEIGHT = 249;
export const RECORDING_TILE_SMALLER_WIDTH = 249;

export const StyledRecordingTileHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr 1fr;
  gap: ${tokens.spacer.x1};
  padding: ${tokens.spacer.x1pt5} ${tokens.spacer.x2};
  transition: border-color;

  border-bottom: 1px solid ${tokens.color.ui_border};
`;

export const StyledRecordingTileFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${tokens.spacer.x1};
  padding: ${tokens.spacer.x1pt5};
  transition: border-color;

  color: ${tokens.color.primary_cta};
  border-top: 1px solid ${tokens.color.ui_border};
`;

export const StyledRecordingTileMainURL = styled.span`
  ${tokens.truncateText()};
  display: inline-block;
  max-width: 95%;
  padding: 2px ${tokens.spacer.x1};

  background: ${tokens.color.cobalt_200};
  border-radius: ${tokens.radius.m};

  transition: background-color 300ms linear;
`;

export const StyledRecordingTileContainer = styled.div`
  min-width: ${RECORDING_TILE_WIDTH}px;
  height: ${RECORDING_TILE_HEIGHT}px;

  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr auto;

  background: ${tokens.color.white};
  border: 1px solid ${tokens.color.ui_border};
  border-radius: ${tokens.radius.m};

  cursor: pointer;
  transition: background-color 300ms linear;

  &:hover {
    background: ${tokens.color.bg_active};
    border-color: ${tokens.color.ui_border_active};

    ${StyledRecordingTileHeader},
    ${StyledRecordingTileFooter} {
      border-color: ${tokens.color.neutral_400};
    }

    ${StyledRecordingTileMainURL} {
      background: ${tokens.color.cobalt_300};
    }
  }
`;

export const StyledRecordingTileHeaderIcons = styled.div`
  display: flex;
  justfiy-content: flex-end;
  align-items: center;
  gap: ${tokens.spacer.x2};
`;

export const StyledRecordingTileFlag = styled.div`
  svg {
    border: solid 1px ${tokens.color.neutral_500};
  }
`;

export const StyleRecordingTileDuration = styled(Text)`
  text-align: right;
`;

export const StyledRecordingTileMainContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 ${tokens.spacer.x2};
`;

export const StyledRecordingTileMainContentOrnament = styled.div`
  margin: ${tokens.spacer.x3pt5} ${tokens.spacer.x1pt5} ${tokens.spacer.x3pt5} 0;
  align-self: stretch;
  width: 3px;
  position: relative;

  background: ${tokens.color.cobalt_600};
  border-radius: 3px;

  &:before,
  &:after {
    content: '';
    height: 4px;
    width: 4px;
    display: inline-block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 100%;
    background: ${tokens.color.cobalt_600};
  }

  &:before {
    top: -10px;
  }

  &:after {
    bottom: -10px;
  }
`;

export const StyledRecordingTileMainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${tokens.spacer.x0pt5};
  flex: 1;
  overflow: hidden;
`;

export const StyledRecordingTileMainContainerRow = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${tokens.spacer.x0pt5};
`;

export const StyledRecordingTileMainSpacer = styled.span`
  padding: 0 ${tokens.spacer.x0pt5};

  &:after {
    content: '•';
  }
`;
